export default __webpack_public_path__ + "static/media/a024-7.289c3701.svg";